import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserStorage } from '../../helper';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    // styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
    constructor(
        private router: Router,
        private userStorage: UserStorage,
        private route: ActivatedRoute
    ) {
        
        this.route.url.subscribe(res => {
            console.log(res);
            // userStorage.saveLocalUser({
            //     "id":1,"email":"pentagon-v2-uat@gmail.com",
            //     "firstName":"pentagon",
            //     "lastName":"admin",
            //     "teamId":10000,
            //     "teamName":null,
            //     "role":2,
            //     "isActive":1,
            //     "createTime":"2018-08-06 12:08:24",
            //     "modifyTime":"2021-06-16 17:11:50"
            // });
        })
     }

    ngOnInit() {}
 }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/home.component.ts